<template>
    <router-link
        v-slot="{ href, route, navigate, isActive, isExactActive }"
        :to="{ name: 'PromptEditorCanvas', params: { uuid: id } }"
    >
        <button @click="navigate" id="prompt-editor-nav-btn" class="w-100">
            <div class="d-flex align-items-center gap-5">
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M1.33325 0.666626L4.66659 3.99996L1.33325 7.33329M6.66659 7.33329H10.6666"
                        stroke="white"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
                <span>{{ 'Prompt Editor' | trans }}</span>
            </div>
            <i class="fa fa-chevron-right"></i>
        </button>
    </router-link>
</template>
<script>
import store from '../../../mixins/store.mixin';
import current_job from '../../../mixins/current_job.mixin';
export default {
    name: 'PromptEditorNavBtn',
    mixins: [store, current_job],
};
</script>
<style lang="scss" scoped>
#prompt-editor-nav-btn {
    min-height: 38px;
    background-color: #383838;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border: 1px solid #595959;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    color: #e8eaed;
    &:hover {
        background: #323232;
    }
}
</style>
